import { IKeyValue } from "@/api/AppApi/services/filters/interfaces/IGetFilters";
import { IProductDetails } from "@/api/AppApi/services/product/interfaces/api-product-details-interface";

export const findChildernImages = (
  children: IProductDetails[],
  filter: IKeyValue[]
) => {
  const fillterImages = filter.map((f) => {
    const child = children.find((child) =>
      child.attribute_ids.includes(+f.key)
    );
    return { ...f, image_url: child?.image_url ?? "" };
  });
  return fillterImages;
};
